import { useTheme } from '../providers/ThemeProvider';
import { Tooltip } from '@localagent/ui/components/tooltip';

const THEME_LABEL = { light: 'Light', dark: 'Dark', system: 'System' } as const;

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    if (theme === 'light') {
      setTheme('dark');
    } else if (theme === 'dark') {
      setTheme('system');
    } else {
      setTheme('light');
    }
  };

  const value = THEME_LABEL[theme];

  return (
    <Tooltip label={`Change theme (currently ${value})`}>
    <button
      type="button"
      data-testid="theme-toggle"
      onClick={toggleTheme}
      aria-label="Change theme"
      title={`Theme: ${value}`}
      className="rounded-md p-1.5 text-muted-foreground transition-colors hover:bg-accent"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {theme === 'light' && (
          <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
          </>
        )}
        {theme === 'dark' && <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />}
        {theme === 'system' && (
          <>
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <path d="M8 21h8M12 17v4" />
          </>
        )}
      </svg>
    </button>
    </Tooltip>
  );
}
